import { createApiClient } from '@deltax/idp-api-client'
import qs from 'qs'

import appConfig from '@/constants/appConfig'

export const isEmbedded = window.self !== window.top

const clientId = import.meta.env.VITE_DELTAX_CLIENT_APP_ID || appConfig.STUNNR_BE_CLIENT_ID

export const { apiClient, authService } = createApiClient({
  clientId,
  resourceApiBaseUrl: import.meta.env.VITE_DX_API_URL,
  idpBaseUrl: import.meta.env.VITE_IDP_BASE_URL,
  isEmbedMode: isEmbedded,
  accessTokenStorageKey: isEmbedded ? (import.meta.env.VITE_EMBED_ACCESS_TOKEN_STORAGE_KEY || 'dx_embed_access_token') : undefined,
})

const paramsSerializer = (params: Record<string, any>) =>
  qs.stringify(params, { arrayFormat: 'indices', allowDots: true })

apiClient.axiosInstance.defaults.paramsSerializer = paramsSerializer
